import { Link } from 'react-router-dom';
import { shows, type Show } from '@/mocks/shows';

interface ShowCardProps {
  show: Show;
}

function ShowCard({ show }: ShowCardProps) {
  return (
    <Link
      to={`/article/${show.id}`}
      className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={show.coverImage}
          alt={show.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${show.title} - 星辰影院热门综艺`}
        />
        <div className="absolute top-3 left-3 flex items-center gap-1.5 flex-wrap">
          {show.isNew && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
              新
            </span>
          )}
          {show.isHot && (
            <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
              热
            </span>
          )}
        </div>
        <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-black/60 backdrop-blur-sm text-background-50 text-xs">
          {show.episodes}期
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1.5 line-clamp-1">
          {show.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 mb-3 line-clamp-2">
          {show.description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">{show.host}</span>
          <span className="flex items-center gap-1 text-xs text-primary-600 font-medium">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-xs"></i>
            </div>
            {show.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}

interface HotShowsProps {
  title?: string;
  filter?: (show: Show) => boolean;
  limit?: number;
}

export default function HotShows({ title = '热门推荐', filter, limit = 8 }: HotShowsProps) {
  const filteredShows = filter ? shows.filter(filter) : shows;
  const displayShows = filteredShows.slice(0, limit);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              {title}
            </h2>
            <p className="text-foreground-500 text-sm">
              精选优质综艺，等你来发现
            </p>
          </div>
          <Link
            to="/category/hot"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayShows.map((show) => (
            <ShowCard key={show.id} show={show} />
          ))}
        </div>
      </div>
    </section>
  );
}